import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["icon", "onHover", "onClick", "size", "className", "iconClassName", "fill", "attributes"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.fill.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import { Icon } from "../../Icon/Icon/Icon";
import styles from "./IconButton.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var IconButton = function IconButton(_ref) {
  var icon = _ref.icon,
    _ref$onHover = _ref.onHover,
    onHover = _ref$onHover === void 0 ? function () {} : _ref$onHover,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '14px' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$iconClassName = _ref.iconClassName,
    iconClassName = _ref$iconClassName === void 0 ? '' : _ref$iconClassName,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? '' : _ref$fill,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var onClickHandler = function onClickHandler(event) {
    event.preventDefault();
    onClick && onClick(event);
  };
  var onHoverChange = function onHoverChange(hover) {
    onHover && onHover(hover);
  };
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
    type: "button",
    className: classnames(styles.iconButton, className),
    onClick: onClickHandler,
    onMouseEnter: function onMouseEnter() {
      onHoverChange(true);
    },
    onMouseLeave: function onMouseLeave() {
      onHoverChange(false);
    }
  }, attributes), otherProps), {}, {
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(Icon, {
        className: iconClassName,
        width: size,
        height: size,
        type: icon,
        fill: fill
      })
    })
  }));
};